// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Page wrapper ── */
.lm-page {
  display: flex;
  justify-content: center;
  padding: 24px 16px 64px;
  min-height: 100%;
}

.lm-container {
  width: 100%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Back button ── */
.lm-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: #9aa3ad;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
  width: fit-content;
  transition: color 0.15s ease;
}

.lm-back:hover {
  color: #48D1CC;
}

/* ── Header ── */
.lm-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.lm-header-icon-wrap {
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 16px;
  background: rgba(59, 179, 174, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}

.lm-header-icon {
  color: #48D1CC !important;
  font-size: 28px !important;
}

.lm-title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
}

.lm-subtitle {
  margin: 4px 0 0;
  color: #9aa3ad;
  font-size: 14px;
}

/* ── Progress card ── */
.lm-progress-card {
  background: #0e1b1b;
  border-radius: 16px;
  border: 1px solid #484848;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.lm-progress-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.lm-progress-label {
  font-size: 14px;
  font-weight: 600;
  color: #e6eaef;
}

.lm-progress-count {
  font-size: 13px;
  color: #9aa3ad;
}

.lm-progress-bar-track {
  width: 100%;
  height: 8px;
  border-radius: 99px;
  background: #071414;
  overflow: hidden;
}

.lm-progress-bar-fill {
  height: 100%;
  border-radius: 99px;
  background: linear-gradient(90deg, #3BB3AE, #48D1CC);
}

.lm-progress-pct {
  font-size: 13px;
  font-weight: 700;
  color: #48D1CC;
  align-self: flex-end;
}

/* ── Modules list ── */
.lm-modules-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* ── Module card ── */
.lm-module-card {
  background: #0e1b1b;
  border-radius: 16px;
  border: 1px solid #484848;
  overflow: hidden;
  transition: border-color 0.2s ease;
}

.lm-module-open {
  border-color: #3BB3AE;
}

/* ── Accordion header ── */
.lm-module-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: none;
  border: none;
  cursor: pointer;
  gap: 12px;
  text-align: left;
}

.lm-module-header:hover {
  background: rgba(255,255,255,0.03);
}

.lm-module-header-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}

.lm-module-num {
  width: 30px;
  height: 30px;
  min-width: 30px;
  border-radius: 50%;
  background: rgba(59, 179, 174, 0.15);
  color: #48D1CC;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lm-module-title-block {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.lm-module-title {
  font-size: 15px;
  font-weight: 600;
  color: #e6eaef;
  line-height: 1.35;
}

.lm-module-preview {
  font-size: 13px;
  color: #9aa3ad;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 380px;
}

.lm-module-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.lm-visited-icon {
  color: #48D1CC !important;
  font-size: 20px !important;
}

.lm-unvisited-icon {
  color: #484848 !important;
  font-size: 20px !important;
}

.lm-chevron {
  color: #64707d !important;
  font-size: 22px !important;
  transition: transform 0.22s ease;
}

.lm-chevron-open {
  transform: rotate(180deg);
}

/* ── Accordion body ── */
.lm-module-body {
  border-top: 1px solid rgba(72,72,72,0.35);
}

.lm-module-content {
  padding: 16px 20px 20px;
  font-size: 14px;
  color: #c5cdd6;
  line-height: 1.7;
  white-space: pre-wrap;
}

/* ── Exam CTA ── */
.lm-exam-cta {
  margin-top: 8px;
  background: #0e1b1b;
  border-radius: 18px;
  border: 1px solid rgba(75, 111, 255, 0.2);
  padding: 20px;
}

.lm-exam-cta-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.lm-exam-cta-text {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.lm-exam-icon {
  color: #48D1CC !important;
  font-size: 28px !important;
  margin-top: 2px;
}

.lm-exam-cta-title {
  font-size: 16px;
  font-weight: 600;
  color: #e6eaef;
}

.lm-exam-cta-sub {
  font-size: 13px;
  color: #9aa3ad;
  margin-top: 3px;
}

.lm-btn-exam {
  padding: 11px 28px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  background: linear-gradient(135deg, #3BB3AE, #0099a8);
  color: #fff;
  transition: opacity 0.15s ease, transform 0.15s ease;
  white-space: nowrap;
}

.lm-btn-exam:hover {
  opacity: 0.88;
  transform: translateY(-1px);
}

/* ── Error card ── */
.lm-error-card {
  background: #0e1b1b;
  border-radius: 16px;
  border: 1px solid rgba(239, 83, 80, 0.2);
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: #9aa3ad;
  text-align: center;
}

/* ── Empty state ── */
.lm-empty {
  background: #0e1b1b;
  border-radius: 16px;
  border: 1px solid #484848;
  padding: 48px 24px;
  color: #9aa3ad;
  text-align: center;
}

/* ── Skeletons ── */
.lm-header-skeleton {
  display: flex;
  align-items: center;
  gap: 16px;
}

.lm-skeleton {
  border-radius: 10px;
  background: linear-gradient(90deg, #0e1b1b 25%, #132828 50%, #0e1b1b 75%);
  background-size: 200% 100%;
  animation: lmSkeleton 1.4s ease infinite;
}

.lm-skel-icon    { width: 56px; height: 56px; border-radius: 16px; }
.lm-skel-title   { width: 180px; height: 20px; margin-bottom: 8px; }
.lm-skel-sub     { width: 120px; height: 14px; }
.lm-skel-progress { width: 100%; height: 72px; border-radius: 16px; }
.lm-skel-card    { width: 100%; height: 60px; border-radius: 16px; }

@keyframes lmSkeleton {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Responsive ── */
@media (max-width: 600px) {
  .lm-title { font-size: 20px; }
  .lm-exam-cta-inner { flex-direction: column; align-items: flex-start; }
  .lm-btn-exam { width: 100%; }
  .lm-module-preview { max-width: 200px; }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Certifications/LearningModules/LearningModules.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qDAAqD;EACrD,WAAW;EACX,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yEAAyE;EACzE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,mBAAmB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACnE,mBAAmB,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACnE,mBAAmB,YAAY,EAAE,YAAY,EAAE;AAC/C,oBAAoB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACpE,mBAAmB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;;AAEnE;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,qBAAqB;AACrB;EACE,YAAY,eAAe,EAAE;EAC7B,qBAAqB,sBAAsB,EAAE,uBAAuB,EAAE;EACtE,eAAe,WAAW,EAAE;EAC5B,qBAAqB,gBAAgB,EAAE;AACzC","sourcesContent":["/* ── Page wrapper ── */\n.lm-page {\n  display: flex;\n  justify-content: center;\n  padding: 24px 16px 64px;\n  min-height: 100%;\n}\n\n.lm-container {\n  width: 100%;\n  max-width: 720px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ── Back button ── */\n.lm-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  color: #9aa3ad;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0;\n  width: fit-content;\n  transition: color 0.15s ease;\n}\n\n.lm-back:hover {\n  color: #48D1CC;\n}\n\n/* ── Header ── */\n.lm-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.lm-header-icon-wrap {\n  width: 56px;\n  height: 56px;\n  min-width: 56px;\n  border-radius: 16px;\n  background: rgba(59, 179, 174, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lm-header-icon {\n  color: #48D1CC !important;\n  font-size: 28px !important;\n}\n\n.lm-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.lm-subtitle {\n  margin: 4px 0 0;\n  color: #9aa3ad;\n  font-size: 14px;\n}\n\n/* ── Progress card ── */\n.lm-progress-card {\n  background: #0e1b1b;\n  border-radius: 16px;\n  border: 1px solid #484848;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.lm-progress-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.lm-progress-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #e6eaef;\n}\n\n.lm-progress-count {\n  font-size: 13px;\n  color: #9aa3ad;\n}\n\n.lm-progress-bar-track {\n  width: 100%;\n  height: 8px;\n  border-radius: 99px;\n  background: #071414;\n  overflow: hidden;\n}\n\n.lm-progress-bar-fill {\n  height: 100%;\n  border-radius: 99px;\n  background: linear-gradient(90deg, #3BB3AE, #48D1CC);\n}\n\n.lm-progress-pct {\n  font-size: 13px;\n  font-weight: 700;\n  color: #48D1CC;\n  align-self: flex-end;\n}\n\n/* ── Modules list ── */\n.lm-modules-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* ── Module card ── */\n.lm-module-card {\n  background: #0e1b1b;\n  border-radius: 16px;\n  border: 1px solid #484848;\n  overflow: hidden;\n  transition: border-color 0.2s ease;\n}\n\n.lm-module-open {\n  border-color: #3BB3AE;\n}\n\n/* ── Accordion header ── */\n.lm-module-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  gap: 12px;\n  text-align: left;\n}\n\n.lm-module-header:hover {\n  background: rgba(255,255,255,0.03);\n}\n\n.lm-module-header-left {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n}\n\n.lm-module-num {\n  width: 30px;\n  height: 30px;\n  min-width: 30px;\n  border-radius: 50%;\n  background: rgba(59, 179, 174, 0.15);\n  color: #48D1CC;\n  font-size: 13px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lm-module-title-block {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.lm-module-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #e6eaef;\n  line-height: 1.35;\n}\n\n.lm-module-preview {\n  font-size: 13px;\n  color: #9aa3ad;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 380px;\n}\n\n.lm-module-header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.lm-visited-icon {\n  color: #48D1CC !important;\n  font-size: 20px !important;\n}\n\n.lm-unvisited-icon {\n  color: #484848 !important;\n  font-size: 20px !important;\n}\n\n.lm-chevron {\n  color: #64707d !important;\n  font-size: 22px !important;\n  transition: transform 0.22s ease;\n}\n\n.lm-chevron-open {\n  transform: rotate(180deg);\n}\n\n/* ── Accordion body ── */\n.lm-module-body {\n  border-top: 1px solid rgba(72,72,72,0.35);\n}\n\n.lm-module-content {\n  padding: 16px 20px 20px;\n  font-size: 14px;\n  color: #c5cdd6;\n  line-height: 1.7;\n  white-space: pre-wrap;\n}\n\n/* ── Exam CTA ── */\n.lm-exam-cta {\n  margin-top: 8px;\n  background: #0e1b1b;\n  border-radius: 18px;\n  border: 1px solid rgba(75, 111, 255, 0.2);\n  padding: 20px;\n}\n\n.lm-exam-cta-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.lm-exam-cta-text {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.lm-exam-icon {\n  color: #48D1CC !important;\n  font-size: 28px !important;\n  margin-top: 2px;\n}\n\n.lm-exam-cta-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #e6eaef;\n}\n\n.lm-exam-cta-sub {\n  font-size: 13px;\n  color: #9aa3ad;\n  margin-top: 3px;\n}\n\n.lm-btn-exam {\n  padding: 11px 28px;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  background: linear-gradient(135deg, #3BB3AE, #0099a8);\n  color: #fff;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n  white-space: nowrap;\n}\n\n.lm-btn-exam:hover {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n/* ── Error card ── */\n.lm-error-card {\n  background: #0e1b1b;\n  border-radius: 16px;\n  border: 1px solid rgba(239, 83, 80, 0.2);\n  padding: 32px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  color: #9aa3ad;\n  text-align: center;\n}\n\n/* ── Empty state ── */\n.lm-empty {\n  background: #0e1b1b;\n  border-radius: 16px;\n  border: 1px solid #484848;\n  padding: 48px 24px;\n  color: #9aa3ad;\n  text-align: center;\n}\n\n/* ── Skeletons ── */\n.lm-header-skeleton {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.lm-skeleton {\n  border-radius: 10px;\n  background: linear-gradient(90deg, #0e1b1b 25%, #132828 50%, #0e1b1b 75%);\n  background-size: 200% 100%;\n  animation: lmSkeleton 1.4s ease infinite;\n}\n\n.lm-skel-icon    { width: 56px; height: 56px; border-radius: 16px; }\n.lm-skel-title   { width: 180px; height: 20px; margin-bottom: 8px; }\n.lm-skel-sub     { width: 120px; height: 14px; }\n.lm-skel-progress { width: 100%; height: 72px; border-radius: 16px; }\n.lm-skel-card    { width: 100%; height: 60px; border-radius: 16px; }\n\n@keyframes lmSkeleton {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ── Responsive ── */\n@media (max-width: 600px) {\n  .lm-title { font-size: 20px; }\n  .lm-exam-cta-inner { flex-direction: column; align-items: flex-start; }\n  .lm-btn-exam { width: 100%; }\n  .lm-module-preview { max-width: 200px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
